module.exports = __webpack_public_path__ + "img/arr-right.4098f47f.svg";